<template>
	<div class="quotes-container">
		<div class="container">
			<h3 class="title">{{ title }}</h3>
			<div class="quotes" ref="quotes" :style="{ minHeight }">
				<div v-for="(quote, index) in quotes" class="quote" :class="{ active: active === index }">
					<blockquote v-html="quote[`quote_${lang}`]"></blockquote>
					<span class="author">
						<h3 v-html="quote[`title_${lang}`]"></h3>
						<div v-html="quote[`author_${lang}`]"></div>
					</span>
				</div>
			</div>
		</div>
		<button class="controls prev" @click="prev"><i class="ion-arrow-left-c"></i></button>
		<button class="controls next" @click="next"><i class="ion-arrow-right-c"></i></button>
	</div>
</template>

<script>
	export default {
		mounted() {
			this.quoteElements = this.$refs.quotes.querySelectorAll('.quote');
			this.quoteElements.forEach(el => {
				if(el.getBoundingClientRect().height > this.highest) this.highest = el.getBoundingClientRect().height;
			});

			this.interval = setInterval(() => {
				var current = this.active;
				this.active = current >= (this.quotes.length - 1) ? 0 : current + 1;
			}, 16000);
		},
		computed: {
			minHeight() {
				return `${this.highest}px`;
			},
			lang() {
				return this.$route.params ? (this.$route.params.lang || 'en') : 'en';
			},
			title() {
				switch(this.lang) {
					case 'hu':
						return 'Rólunk mondták';
					default: 
						return 'Others about CÉH';
				}
			}
		},
		methods: {
			prev() {
				clearInterval(this.interval);
				this.active = this.active === 0 ? this.quotes.length - 1 : this.active - 1;
			},
			next() {
				clearInterval(this.interval);
				this.active = this.active >= (this.quotes.length - 1) ? 0 : this.active + 1;
			}
		},
		data() {
			return {
				interval: {},
				active: 0,
				highest: 0,
				quoteElements: [],
				quotes: [
					{
						quote_en: `I love working with CÉH colleagues as they are like a huge company of friends where people are attached to one another in different ways. We pay attention and even give help to one another, if necessary. There are many of us with wide expertise and this is why we are able to find the solution to each problem.<br>This is the case when I’m only a minor contributor in the system or even when I am the party that asks CÉH to offer a subcontractor or designer for my own project.`,
						author_en: `Krisztina Wallner<br>Landscape and Garden Engineer`,
						title_en: `TILIA Kertészeti BT.`,

						quote_hu: `Azért szeretek a Céhesekkel dolgozni, mert olyan, mint egy hatalmas baráti társaság, melyben az emberek különböző erősséggel kötődnek egymáshoz. Odafigyelünk egymásra, ha szükséges, segítünk egymáson. Sokan vagyunk, szerteágazó szaktudással, így megoldást mindenre tudunk találni.<br>Ez akkor is működik, ha kis pont vagyok a rendszerben és akkor is, ha én kérek a Céhből alvállalkozó-tervezőt saját projektemhez.`,
						author_hu: 'Wallner Krisztina<br>Táj-és kertépítész vezető tervező',
						title_hu: `TILIA Kertészeti BT.`,

						quote_de: `Ich arbeite gerne mit den Mitarbeitern der Firma CÉH zusammen, weil sie wie eine riesige Gesellschaft von Freunden ist, in der die Menschen unterschiedlich stark miteinander verbunden sind. Wir achten aufeinander gegenseitig, wenn es notwendig ist, helfen wir einander. Wir sind viele, mit weitverzweigten Fachkenntnissen, so können für alles eine Lösung finden.<br>Das funktioniert auch, wenn ich ein kleiner Punkt im System bin, und auch dann, wenn ich bei der Firma CÉH um einen Planer als Subunternehmer für mein eigenes Projekt bitte.`,
						author_de: `Landschafts- und Gartenarchitektin, leitende Planerin`,
						title_de: `TILIA Gartenbau KG`
					},
					{
						quote_en: `I’ve been working for CÉH zRt. for about twenty years. During this period I’ve been given the opportunity to make plans together with CÉH engineers, colleagues or almost friends for the facilities of outstanding clients such as TESCO, Bridgeston, Hankook, Apollo, Lego and SMP. It is a special feeling that I can again meet old hands and discuss the questions of current projects in the conference room – as a result, time is given quite another meaning! And it is true that CÉH is a constantly changing, innovative and stable team which one is keen on belonging to!<br><br>Thanks so much!`,
						author_en: 'Gábor Verebi',
						title_en: `VG Projekt Kft.`,
						quote_hu: `Mintegy húsz esztendeje dolgozom a CÉH zRt. oldalán. Többek között olyan neves megrendelők, mint a TESCO, Bridgeston, Hankook, Apollo, Lego, SMP létesítményeit tervezhettük együtt a CÉH-es mérnökökkel, kollégákkal, már-már barátokkal. Különleges érzés, a mostani projekteken a régi motorosokkal újra és újra egy tárgyalóban találkozni – ezáltal mintha az idő is valamilyen más jelentést nyerne! És valóban a CÉH egy mindig változó és folyamatosan megújuló, de állandóan stabil csapat, ahova jó tartozni!<br><br>Köszönöm!`,
						author_hu: 'Verebi Gábor',
						title_hu: `VG Projekt Kft.`,
						quote_de: `„Seit etwa zwanzig Jahren arbeite ich an der Seite der Firma CÉH zRt. [geschl. AG]. Zusammen mit den Ingenieuren, Kollegen, beinahe Freunden bei der Firma CÉH konnten wir Einrichtungen für solche namhaften Auftraggeber wie TESCO, Bridgestone, Hankook, Apollo, Lego, SMP planen. Es ist ein besonderes Gefühl, bei den jetzigen Projekten immer wieder den „alten Hasen“ im Verhandlungsraum zu begegnen – als ob die Zeit dadurch eine andere Bedeutung bekommen würde! Und tatsächlich ist die Firma CÉH eine sich immer verändernde und kontinuierlich erneuernde, aber ständig stabile Mannschaft, und es ist gut, zu ihr zu gehören!<br><br>Danke!`,
						author_de: 'Gábor Verebi',
						title_de: `VG Projekt Kft.`,
					},
					{
						quote_en: `“CÉH Zrt. performed high-quality professional work when designing our Sports Hall, meeting all the requirements of the client and of the professional review boards (Tiszáninnen Reformed Church District, National Advisory Board of Monument and Heritage Protection, chief architect of the city). The building they created perfectly fits its environment, it has a very clear and simple design, and yet it is practical. In the course of the design process and the construction, not only was the professional work of the company’s staff excellent, they also had an exemplary attitude. We would like to express our thanks again to the management and staff of the company.”`,
						author_en: `BUZÁSNÉ NAGY Gabriella, Chair of the Board, SRKG Foundation, on behalf of the Foundation`,
						title_en: `Sárospataki Református Kollégium Gimnáziumáért Alapítvány
(Foundation for the Secondary Grammar School of the Reformed College of Sárospatak)`,
						quote_hu: `„A CÉH Zrt. Sportcsarnokunk tervezése során nagyon magas színvonalú szakmai munkát végzett, úgy a megrendelő, mint a szakmai bíráló fórumok (Tiszáninneni Református Egyházkerület, Országos Műemléki és Örökségvédelmi Tanácsadó Testület, városi főépítész) minden elvárásának megfelelt. A környezetbe illő és nagyon letisztult formájú, de ugyanakkor praktikus építményt sikerült tervezniük. A cég képviselői a tervezés és a kivitelezés során nem pusztán szakmai szempontból, hanem emberi hozzáállásukból is jelesre vizsgáztak. E helyen is köszönetünket fejezzük ki a cég vezetőinek és munkatársainak.”`,
						author_hu: `Buzásné Nagy Gabriella, az SRKG Alapítvány kuratóriumának elnöke, mint az Alapítvány képviselője`,
						title_hu: `Sárospataki Református Kollégium Gimnáziumáért Alapítvány`,
						quote_de: `„Beim Entwurf unserer Sporthalle hat die CÉH Zrt. auf hohem fachlichen Niveau gearbeitet und allen Anforderungen des Auftraggebers, sowie der fachlichen Prüforgane (Reformierter Kirchenbezirk Tiszáninnen, Nationale Beraterkörperschaft für Denkmalschutz und Schutz des kulturellen Erbes, städtischer leitender Architekt) entsprochen. Es gelang ihnen ein in sein Umfeld passendes, sehr minimalistisches und gleichzeitig praktisches Gebäude zu entwerfen. Die Vertreter der Firma stellten bei der Planung und Ausführung nicht nur ihre fachlichen Aspekte, sondern auch ihre humane Einstellung unter Beweis. Auch an dieser Stelle möchten wir den Leitern und Mitarbeitern der Firma unseren Dank aussprechen.”`,
						author_de: `Gabriella Búzásné Nagy, Vorsitzende des Kuratoriums der Stiftung SRKG als Vertreterin der Stiftung`,
						title_de: `Stiftung für das Gymnasium des Reformierten Internats von Sárospatak`,
					}
				]
			}
		}
	}
</script>

<style lang="scss" scoped>

    @import "./../../sass/variables";

	.controls {
		background-color: rgba(255,255,255,0.1);
		transform: translateY(-50%);
		position: absolute;
		color: $light-blue;
		display: block;
		border: none;
		height: 60px;
		width: 60px;
		top: 40%;

		i {
			color: $light-blue;
			font-size: 200%;
		}

		&:hover {
			background-color: rgba(255,255,255,0.2);
		}

		&.prev {
			left: 0;
		}
		&.next {
			right: 0;
		}
	}

	.quotes-container {
		background-color: $blue;
		padding-bottom: 80px;
		position: relative;
		padding-top: 80px;
		color: #fff;

		@media screen and (max-width: $mobile-max) {
			padding-bottom: 40px;
			padding-top: 40px;
		}

		.container {
			max-width: 75%;

			@media screen and (max-width: $mobile-max) {
				max-width: 90%;
			}
		}

		* {
			color: #fff;
		}

		.quotes {
			position: relative;
		}

		.title {
			margin-bottom: 50px;
			margin-top: 30px;

			@media screen and (max-width: $mobile-max) {
				margin-bottom: 20px;
				margin-top: 10px;
			}
		}

		.author {

			h3 {
				margin-bottom: 5px;
				color: $light-blue;
			}

			div {
				
			}
		}

		.quote {
			transition: all 500ms;
			position: absolute;
		    line-height: 1.6;
			opacity: 0;
			left: 0;
			top: 0;

			&.active {
				transition: all 500ms 500ms;
				opacity: 1;
			}

			blockquote {
				background-color: transparent;
				font-size: 20px;
				line-height: 2;

				@media screen and (max-width: $mobile-max) {
				    line-height: 1.6;
				    font-size: 16px;
				    padding: 0;
				}
			}
		}
	}

</style>